import clsx from "clsx";
import FormGridInput from "../FormGridInput/FormGridInput";
import { FormGridRowRoot, FormGridLeftCell, FormGridRightCell } from "./FormGridRow.styles";
import { FormGridRowProps } from "./FormGridRow.types";
import { FormGridLabel } from "../FormGridLabel/FormGridLabel";

function FormGridRow({ className, editable, label, style, viewOnly, popover, ...inputProps }: FormGridRowProps) {
    const finalInputProps = { ...inputProps, readonly: inputProps.readonly || !editable, hideError: inputProps.hideError || !editable };

    const showOptionalLabel = inputProps.required !== true && viewOnly !== true;

    return (
        <FormGridRowRoot className={clsx("form-grid-row", className)} style={style} viewOnly={viewOnly}>
            {" "}
            {/* skipcq: JS-0415 */}
            <FormGridLeftCell className={clsx("form-grid-left-cell form-grid-cell", { editable })}>
                <FormGridLabel label={label} showOptionalLabel={showOptionalLabel} popover={popover} />
            </FormGridLeftCell>
            <FormGridRightCell className={clsx("form-grid-right-cell form-grid-cell", { editable })}>
                {/*@ts-ignore inputProps is typesafe by the FormGridInputProps */}
                <FormGridInput {...finalInputProps} />
            </FormGridRightCell>
        </FormGridRowRoot>
    );
}

export default FormGridRow;
